import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { parse, stringify } from 'query-string';
import { updateFilters } from 'store/actions/listActions';

export default function (WrappedComponent) {
    class ListQueryFilter extends React.Component {
        constructor(props) {
            super(props);

            const {
                filterList,
                initialFilters,
                location,
            } = props;

            const hasFilters = !utils.isEmpty(filterList.filter);
            const hasInitialFilters = !utils.isEmpty(initialFilters);

            let loadingState = false;

            const urlSearchString = location.search;

            if (urlSearchString) {
                this.setupQueryFilters(urlSearchString);

                loadingState = true;
            } else if (hasInitialFilters && !hasFilters) {
                this.setupInitialFilters({
                    filter: initialFilters,
                });

                loadingState = true;
            }

            this.state = {
                loading: loadingState,
            };
        }

        componentDidMount() {
            const {
                loading,
            } = this.state;

            if (loading) {
                this.setState({
                    loading: false,
                });
            }
        }

        setupQueryFilters = (queryString) => {
            const {
                actionType,
            } = this.props;

            if (!actionType) {
                throw new Error('listQueryFilter: actionType is not defined');
            }

            let queryParams = parse(queryString);

            if (utils.isString(queryParams.filter)) {
                queryParams.filter = JSON.parse(queryParams.filter);
            }

            // Update the queryParams in the redux state.
            this.setupInitialFilters(queryParams);
        }

        setupInitialFilters = (filters) => {
            const {
                dispatchNewFilters,
            } = this.props;

            dispatchNewFilters(filters);
        }

        updateQuery = (params) => {
            const {
                filterList,
                location,
            } = this.props;

            let newQuery = {
                page: 1,
                ...filterList,
                ...params,
            };

            // Let's cleanup Objects that are empty.
            newQuery = utils.filterEmptyValues(newQuery);

            /**
             * Merge and stringify the search values together.
             * The filter can be a multi-layered object, so we need to stringify this seperataly.
             * @todo Merge the stringify into one function.
             */
            const searchUrl = stringify({
                ...newQuery,
                filter: JSON.stringify(newQuery.filter),
            });

            const newUrl = [
                location.pathname,
                searchUrl ? searchUrl : '',
            ].join('?');

            window.history.pushState(null, null, newUrl);
        }

        render() {
            const {
                loading,
            } = this.state;

            if (loading) {
                return null;
            }

            return <WrappedComponent
                { ...this.props }
                updateQuery={ this.updateQuery }
            />;
        }
    }

    const selectFilterData = (state) => {
        return {
            field: state.field,
            filter: state.filter,
            filterCategory: state.filterCategory,
            order: state.order,
            page: state.page,
            size: state.size,
        };
    };

    const mapStateToProps = (state, props) => {
        const {
            resource,
        } = props;

        if (!resource) {
            throw new Error('no resource has been defined');
        }

        const stateResource = state[resource];

        if (!stateResource) {
            throw new Error('no stateResource has been defined');
        }

        return {
            filterList: selectFilterData(stateResource),
        };
    };

    const mapDispatchToProps = (dispatch, props) => {
        const {
            actionType,
        } = props;

        return {
            dispatchNewFilters: (newFilters) => {
                dispatch(updateFilters(actionType, newFilters));
            },
        };
    };

    ListQueryFilter.defaultProps = {
        initialFilters: {},
    };

    ListQueryFilter.propTypes = {
        actionType: PropTypes.string.isRequired,
        dispatchNewFilters: PropTypes.func.isRequired,
        filterList: PropTypes.object.isRequired,
        initialFilters: PropTypes.object,
        location: PropTypes.shape({
            pathname: PropTypes.string,
            search: PropTypes.string,
        }).isRequired,
    };

    return connect(
        mapStateToProps,
        mapDispatchToProps,
    )(ListQueryFilter);
}



// WEBPACK FOOTER //
// ./src/components/hoc/listQueryFilter.js